"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("../../typography");
var styles_1 = require("../../typography/Label/styles");
exports.Wrapper = styled_components_1.default(typography_1.Label)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  white-space: nowrap;\n  border: 1px solid currentColor;\n  border-radius: 3em;\n  background-color: white;\n  padding: 0.45em calc(0.75em - ", ") 0.34em 0.75em;\n  line-height: 1;\n"], ["\n  display: inline-block;\n  white-space: nowrap;\n  border: 1px solid currentColor;\n  border-radius: 3em;\n  background-color: white;\n  padding: 0.45em calc(0.75em - ", ") 0.34em 0.75em;\n  line-height: 1;\n"])), styles_1.LETTER_SPACING);
var templateObject_1;
